const baseApiUrl = process.env.VUE_APP_MAIN_DOMAIN_URL;

export const GET_MAIN_CATEGORIES = async () => {
  const response = await fetch(`${baseApiUrl}shop/home-categories/get`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
  });
  const result = await response.json();
  return result;
};

export const GET_MAIN_BUNNER = async () => {
  const response = await fetch(`${baseApiUrl}shop/banners/get`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
  });
  const result = await response.json();
  return result;
};

export const GET_CATEGORIES = async () => {
  const response = await fetch(`${baseApiUrl}shop/categories`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
  });
  const result = await response.json();
  return result;
};

export const GET_CATEGORY = async (category) => {
  const response = await fetch(`${baseApiUrl}shop/categories/${category}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
  });
  const result = await response.json();
  return result;
};

export const GET_ALL_PRODUCTS = async () => {
  const response = await fetch(`${baseApiUrl}shop/products`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
  });
  const result = await response.json();
  return result;
};

export const GET_ONE_PRODUCT = async (product) => {
  const response = await fetch(`${baseApiUrl}shop/products/${product}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
  });
  const result = await response.json();
  return result;
};

export const GET_SHOP_PRODUCTS_SEARCH = async ({
  q = "",
  category_ids = null,
  price_from,
  price_to,
  sort = "",
}) => {
  const response = await fetch(`${baseApiUrl}shop/products/search`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: JSON.stringify({
      search: q,
      category_ids,
      price_from,
      price_to,
      sort,
    }),
  });
  const result = await response.json();
  return result;
};

export const GET_SHOP_ORDER_NUMBER = async (id) => {
  const response = await fetch(
    `${baseApiUrl}shop/order/get?customer_id=${id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_CITYS = async ({ order_id, q }) => {
  const response = await fetch(
    `${baseApiUrl}shop/order/city?order_id=${order_id}&q=${q}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_ORDER_BRANCH = async ({ order_id, uuid_city }) => {
  const response = await fetch(
    `${baseApiUrl}shop/order/branch?order_id=${order_id}&uuid_city=${uuid_city}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
  const result = await response.json();
  return result;
};

export const SET_ORDER_BRANCH_SAVE = async (data) => {
  const response = await fetch(`${baseApiUrl}shop/order/branch-save`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_COME_TO_PAY = async (order_id) => {
  const response = await fetch(
    `${baseApiUrl}shop/order/to-pay?order_id=${order_id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_ORDER_CART = async (id) => {
  const response = await fetch(`${baseApiUrl}shop/cart/get?order_id=${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
  });
  const result = await response.json();
  return result;
};

export const GET_ADD_TO_CART = async (data) => {
  const response = await fetch(`${baseApiUrl}shop/cart/add`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_ADD_COUNTER_CART = async (data) => {
  const response = await fetch(`${baseApiUrl}shop/cart/plus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_MINUS_COUNTER_CART = async (data) => {
  const response = await fetch(`${baseApiUrl}shop/cart/minus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_DELETE_CART = async (data) => {
  const response = await fetch(`${baseApiUrl}shop/cart/delete`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_CHANGE_PRODUCT_QUANTITY = async (data) => {
  const response = await fetch(`${baseApiUrl}shop/cart/quantity`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
  const result = await response.json();
  return result;
};
